/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'btn-arrow': {
    width: 9,
    height: 16,
    viewBox: '0 0 9 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.468 8.53l-6.407 6.408L0 13.878 5.877 8 0 2.123l1.06-1.061L7.469 7.47l.53.53-.53.53z" _fill="#000"/>'
  }
})
